/*
 * Copyright 2016 Lutrons Ltd. All Rights Reserved.
 *
 */
import React from 'react';
import {withRouter} from "react-router";

import ReactDOM from 'react-dom';
import uuid from 'node-uuid';
import {Form, FormGroup, FormControl, ControlLabel} from 'react-bootstrap';
import {Glyphicon, Modal, Label, Button, Panel, ListGroup, ListGroupItem, Grid, Row, Col, Image, Checkbox} from 'react-bootstrap';
import ReactSpinner from 'react-spinjs';
import UserStore from '../../stores/UserStore';
import APIActions from '../../actions/apiActions';
import ProductStore from '../../stores/ProductStore';
import AppConstants from '../../constants/AppConstants';
import UIHelpers from '../../library/UIHelpers';
import DataHelpers from '../../library/DataHelpers';
import ProductChannelViewSelector from './productChannelViewSelector';
import ModalConfirmView from "../modalConfirmView";
import ProductAPI from "../../api/awsProductAPI";
import AppDispatcher from "../../dispatcher/AppDispatcher";


class ProductEditView extends React.Component {
    constructor(props) {
        console.log("[ProductEditView] - initialisation");

        super(props);
        this.state = {
            dirty : false,
            saving: false,
            product : null,
            errorMsg : null,
            showObsoleteCheck : false,
            changingImageUrl: null,
            changingName: null,
            changingDesc: null,
            changingRevision: null,
            changingJumper: null,
            allChannels : true,
            deleting : false,
            hidden: false
        };

        this._onProductChange = this._onProductChange.bind(this);
        this.cancelAction = this.cancelAction.bind(this);
        this.deleteCancel = this.deleteCancel.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.toggleHidden = this.toggleHidden.bind(this);
    }

    componentDidMount() {
      console.log("[ProductEditView] - componentDidMount");
      ProductStore.addChangeListener(this._onProductChange) ;

      if (this.props.productUuid === "new") {
        let newUuid = uuid.v4();
        console.debug("Preparing new product with productId " + newUuid);
        let p = {
          "productId": newUuid,
          "name": "New product",
          "desc": "New product description",
          "imageUrl": "http://savaria.azurewebsites.net/images/noimage.png",
          "revision": "1",
          "featureBits": "0",
          "jumperValue": "0",
          "pins": [],
        }
        this.setState({product: p, errorMsg: null});
      }
      else {
          APIActions.getProduct(this.props.productUuid);
      }
    }

    componentWillUnmount() {
        console.log("[ProductsView] - componentWillUnmount");
        ProductStore.removeChangeListener(this._onProductChange);
    }

    _onProductChange(payload) {
        let product = ProductStore.currentProduct() ;
        this.setState({product: product, errorMsg: null});

        if (payload) {
            console.log("PRODUCT PAYLOAD!", payload);
            switch (payload) {
              case AppConstants.PRODUCT_SAVE    :
                  UIHelpers.showMessage("Product info saved") ;
                  this.setState({dirty: false, saving: false});
                  this.props.onFinished(true);
                  break ;
              case AppConstants.PRODUCT_SAVE_ERR:
                UIHelpers.showMessage("Problem saving product");
                this.setState({"saving" : false});
                break ;
              default:
                break ;
            }
        }
    }

    cancelAction() {
        if (this.state.dirty) {
            if (!UIHelpers.confirmAction("You have outstanding changes - are you sure you want to cancel without saving?")) {
              return ;
            }
        }

        this.props.onFinished(false);
    }

    saveChanges() {
        this.setState({"saving" : true});
        APIActions.saveProduct(this.state.product) ;
    }

    changeProductField(fieldName, stateVarForNewValue) {
      if (this.state[stateVarForNewValue]) {  // note: require new value to be non-null and non-empty string
        let p = this.state.product;
        p[fieldName] = this.state[stateVarForNewValue];
        let stateUpdate = { product: p , dirty : true};
        stateUpdate[stateVarForNewValue] = null;
        this.setState(stateUpdate);
      }
    }

    deleteCancel() {
        console.log("Product delete cancelled");
        this.setState({deleting: false});
    }

    deleteConfirm() {
        console.log("TODO: Delete the product: ", this.state.product);
        this.setState({deleting: false});
        let handler = {
            success : (r) => {
                console.log("[API-ACTION] success", r);
                if (r.statusCode && r.statusCode === 200) {
                    this.props.history.push("/products");
                    // AppDispatcher.handleViewAction({
                    //     actionType  : successAction,
                    //     status      : 'OK',
                    //     result      : JSON.parse(r.body)
                    // });
                }
                else {
                    alert("There was a problem deleting the product");
                    // AppDispatcher.handleViewAction({
                    //     actionType  : failAction,
                    //     status      : 'ERROR',
                    //     error       : r.body
                    // });
                }
            },

            failure : (e) => {
                console.log("[API-ACTION] failed", e);
                alert("There was a problem deleting the product");
            }
        };

        ProductAPI.deleteProduct(this.state.product.productId, handler);
    }

    copyProduct() {
      let productName = prompt("Please enter new product name:", this.state.product.name + " - COPY");
      if (productName === null || productName === "") {
        // cancelled
      }
      else {
        let allProducts = ProductStore.products() ;
        let duplicate = false ;
        for (let px in allProducts) {
          let prod = allProducts[px] ;
          if (prod.name === productName) {
            duplicate = true ;
            break ;
          }
        }

        if (duplicate) {
          alert("The product name you entered already exists - " + productName);
          return ;
        }
        else {
          let productCopy = DataHelpers.deepCopy(this.state.product) ;
          productCopy.name = productName ;
          productCopy.productId = uuid.v4();
          this.setState({"saving" : true});
          APIActions.saveProduct(productCopy) ;
        }
      }
    }

    renderChannels() {
      return this.makeTableOfPins("IO Channels", (pin) => { return true; });
    }

    renderRevision() {
      let isAdmin = UserStore.isAdministrator();

      let rev = "1";
      if (this.state.product.revision) {
        rev = this.state.product.revision;
      }
      return <div><b>Revision: </b>{rev}{' '}
      {isAdmin && <a href="#" onClick={()=>this.setState({changingRevision: rev, dirty: true})}><Glyphicon glyph="pencil" style={{color:"blue"}}/></a>}
      </div>;
    }
    renderJumperValue() {
      let isAdmin = UserStore.isAdministrator();

      return <div><b>Jumper: </b>{this.state.product.jumperValue}{' '}
        {isAdmin && <a href="#" onClick={()=>this.setState({changingJumper: this.state.product.jumperValue, dirty: true})}><Glyphicon glyph="pencil" style={{color:"blue"}}/></a>}
        </div>;
    }

    renderSafetyCircuit() {
      return (
        <div>
          <h3>Safety Circuit Rules</h3>
          {this.state.product.pins.map((pin) => {
            let safety = pin.safety || 1;
            if (safety === 1) {
              return null ;
            }

            if (pin.type === "digital") {
              if (safety === 2) {
                return <div><b>{pin.desc}</b>{' '}is ON</div>;
              }
              else {
                return <div><b>{pin.desc}</b>{' '}is OFF</div>;
              }
            }
            else if (pin.type === "voltage") {
              let voltage = pin.voltageCheck || "undefined";
              if (safety === 2) {
                return <div><b>{pin.desc}</b>{' '}is less than {voltage}V</div>;
              }
              else if (safety === 3) {
                return <div><b>{pin.desc}</b>{' '}is {voltage}V</div>;
              }
              else if (safety === 4) {
                return <div><b>{pin.desc}</b>{' '}is more than {voltage}V</div>;
              }
            }
            else {
              return null ;
            }
          })}
        </div>
      )
    }

    renderCriticalFaultCircuit() {
        return (
            <div>
                <h3>Critical Fault Rules</h3>
                {this.state.product.pins.map((pin) => {
                    let critical = pin.critical || 1;
                    if (critical === 1) {
                        return null ;
                    }

                    if (pin.type === "digital") {
                        if (critical === 2) {
                            return <div><b>{pin.desc}</b>{' '}is ON</div>;
                        }
                        else {
                            return <div><b>{pin.desc}</b>{' '}is OFF</div>;
                        }
                    }
                    else if (pin.type === "voltage") {
                        let voltage = pin.voltCritical || "undefined";
                        if (critical === 2) {
                            return <div><b>{pin.desc}</b>{' '}is less than {voltage}V</div>;
                        }
                        else if (critical === 3) {
                            return <div><b>{pin.desc}</b>{' '}is {voltage}V</div>;
                        }
                        else if (critical === 4) {
                            return <div><b>{pin.desc}</b>{' '}is more than {voltage}V</div>;
                        }
                    }
                    else {
                        return null ;
                    }
                })}
            </div>
        )
    }

    renderStringGetterModal(stateItemName, titleText, labelText, onSuccessCallback) {
      return (
          <Modal show={this.state[stateItemName] != null} onHide={()=>{let a={}; a[stateItemName]=null; this.setState(a)}}>
            <Modal.Header closeButton>
              <Modal.Title>{titleText}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <FormGroup>
                  <ControlLabel>{labelText}:</ControlLabel>
                  <FormControl type="text" value={this.state[stateItemName] ? this.state[stateItemName] : ""}
                    ref={(e) => e && ReactDOM.findDOMNode(e).focus()}
                    onChange={(e)=>{let a={}; a[stateItemName]=e.target.value; this.setState(a)}}/>
                </FormGroup>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={()=>{let a={}; a[stateItemName]=null; this.setState(a)}}>Cancel</Button>
              <Button bsStyle="success" onClick={()=>onSuccessCallback()}>Ok</Button>
            </Modal.Footer>
          </Modal>);
    }

    pinEditComplete(changed) {
      if (changed) {
        this.setState({dirty: true});
      }
    }

    toggleHidden() {
        let p = this.state.product ;
        if (p.hidden === null || p.hidden === undefined) {
            p.hidden = true ;
        }
        else {
            p.hidden = !p.hidden ;
        }

        this.setState({dirty: true});
    }

    render() {
      if (!this.state.product || this.state.saving) {
        return (<ReactSpinner/>);
      }

      let isAdmin = UserStore.isAdministrator();

      return (
        <div>
          <div className="pull-right">
              <Button onClick={() => this.props.history.push("/products")}><Glyphicon glyph="arrow-left"/>{' '}Back to Product List</Button>
              {' '}{' '}
              <Button bsSize="small" bsStyle="danger" onClick={()=>this.cancelAction()}><Glyphicon glyph="remove"/>Cancel</Button>
              {' '}
              {isAdmin && <Button bsSize="small" disabled={!this.state.dirty} bsStyle="success" onClick={()=>this.saveChanges()}><Glyphicon glyph="save"/>{' '}Save</Button>}
          </div>
            <ModalConfirmView
                visible={this.state.deleting}
                title="Confirm Product Delete"
                message="Are you sure you want to delete this Product?"
                onCancel={this.deleteCancel}
                onConfirm={this.deleteConfirm} />
          <Panel  bsStyle={this.state.dirty ? "danger" : "success"} >
            <Grid>
                <Row >
                  <Col>
                    <b>Name: </b>
                    {this.state.product.name}
                    {isAdmin && <a href="#" onClick={()=>this.setState({changingName: this.state.product.name, dirty: true})}><Glyphicon glyph="pencil" style={{color:"blue"}}/></a>}
                  </Col>
                </Row>
                <Row >
                  <Col>
                    <b>Description: </b>
                    {this.state.product.desc}
                    {isAdmin && <a href="#" onClick={()=>this.setState({changingDesc: this.state.product.desc, dirty: true})}><Glyphicon glyph="pencil" style={{color:"blue"}}/></a>}
                  </Col>
                </Row>
                <Row >
                    <Col>
                        <Checkbox validationState="success" checked={this.state.product.hidden || false} onChange={this.toggleHidden}>
                            Hide from public view
                        </Checkbox>
                    </Col>
                </Row>
                <Row >
                    <Col>
                        <br/>
                    </Col>
                </Row>
                <Row >
                    {isAdmin &&
                        <Col md={2}>
                            <Button bsStyle="info" disabled={this.state.dirty} block onClick={this.copyProduct.bind(this)}><Glyphicon glyph="copy"/>{' '}Create a Copy</Button>
                        </Col>
                    }
                    {isAdmin &&
                        <Col md={2}>
                            <Button bsStyle="danger" block onClick={() => this.setState({deleting: true})}><Glyphicon glyph="trash"/>{' '}Delete Product</Button>
                        </Col>
                    }
                </Row>
                <Row >
                  <Col md={3}>
                    <Image src={this.state.product.imageUrl} thumbnail />
                    <br/>
                    {isAdmin && <Button bsSize="small" block onClick={()=>this.setState({changingImageUrl: this.state.product.imageUrl, dirty: true})}>Change image</Button>}
                    <br />
                    {this.renderRevision()}
                    {this.renderJumperValue()}
                    {this.renderSafetyCircuit()}
                    {this.renderCriticalFaultCircuit()}
                  </Col>
                  <Col md={8}>
                    <ProductChannelViewSelector product={this.state.product} onFinished={this.pinEditComplete.bind(this)} />
                  </Col>
                </Row>
              </Grid>
          </Panel>

          {this.renderStringGetterModal("changingImageUrl", "Change image", "Image URL", ()=>this.changeProductField("imageUrl", "changingImageUrl"))}
          {this.renderStringGetterModal("changingName", "Change name", "Name", ()=>this.changeProductField("name", "changingName"))}
          {this.renderStringGetterModal("changingDesc", "Change description", "Description", ()=>this.changeProductField("desc", "changingDesc"))}
          {this.renderStringGetterModal("changingRevision", "Change revision", "Revision", ()=>this.changeProductField("revision", "changingRevision"))}
          {this.renderStringGetterModal("changingJumper", "Change jumper-value", "Jumper-value", ()=>this.changeProductField("jumperValue", "changingJumper"))}

        </div>
      );
    }
}


export default withRouter(ProductEditView);



// WEBPACK FOOTER //
// ./src/app/components/products/ProductEditView.react.js